<app-select-search-data #selectSearch
                        [parentFormGroup]="parentFormGroup"
                        [parentFormControlName]="parentFormControlName"
                        [noEntriesFoundLabel]="noEntryPlaceHolder"
                        [placeHolderLabel]= "placeHolder"
                        [service]="partnerSearchService"
                        [sort]="sort"
                        [parameterSearch]="parameterSearch"
                        [additionalUrlParameters]="additionalUrlParameters"
                        [newItemModalOptions]="newItemModalOptions"
                        [value]="value"
                        [eraseSelectionEnabled]="true"
                        [searchTerm]="searchTerm"
                        [automaticSelectIfOneResult]="automaticSelectIfOneResult"
                        (itemSelectEvent)="change($event)">
  <ng-template template-content let-element='element'>
      <div class="d-flex gap-5">
          <div [innerHTML]="getLabel(element)"></div>
          <app-tags-summary-field *ngIf="element.tagEntityType as tagEntityType" [entityType]="tagEntityType" [entityId]="element.id"></app-tags-summary-field>
      </div>
  </ng-template>
</app-select-search-data>

